/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Player_Doc_UnavailableInputs */

const en_mobile_player_doc_unavailable = /** @type {(inputs: Mobile_Player_Doc_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This document is no longer available. It may have been removed from your library.`)
};

const es_mobile_player_doc_unavailable = /** @type {(inputs: Mobile_Player_Doc_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este documento ya no está disponible. Es posible que se haya eliminado de tu biblioteca.`)
};

/**
* | output |
* | --- |
* | "This document is no longer available. It may have been removed from your library." |
*
* @param {Mobile_Player_Doc_UnavailableInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_player_doc_unavailable = /** @type {((inputs?: Mobile_Player_Doc_UnavailableInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Player_Doc_UnavailableInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_player_doc_unavailable(inputs)
	return en_mobile_player_doc_unavailable(inputs)
});